import { useEffect } from 'react';

import { AnalyticsEventActions, AnalyticsEventSource, useAnalytics } from '../AnalyticsContext';

import { type MountedEvent } from './types';

type Props = MountedEvent;

/**
 * This component tracks page loads
 * Place this component so that it renders once per route.
 */
export const TrackPageLoad = (props: Props) => {
	const analytics = useAnalytics();

	const { name } = props;

	useEffect(() => {
		analytics.pushOperationalEvent({
			source: AnalyticsEventSource.CLIENT_METRICS,
			actionSubject: name,
			action: AnalyticsEventActions.MOUNTED,
		});
	}, [analytics, name]);

	return null;
};

export default TrackPageLoad;
